export const NPS_WIDGET_OPTIONS = {
  ADVISER_SELECTION: 3,
  TIME_PERIOD: 15,
  LAYOUT_VIEW: 18,
  SWITCH_VALUE: 19,
  SHOW_FOR: 14,
  SHOW_FOR_STATE: 21,
};
